<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <footer class="site-footer">
    <div class="footer__glow-line"></div>
    <div class="footer__inner container">
      <div class="footer__brand">
        <span class="footer__logo">🏀</span>
        <span class="footer__name">{{ t('site.name') }}</span>
      </div>
      <nav class="footer__links">
        <router-link to="/" class="footer__link">{{ t('common.home') }}</router-link>
        <router-link to="/articles" class="footer__link">{{ t('common.articles') }}</router-link>
        <router-link to="/tags" class="footer__link">{{ t('common.tags') }}</router-link>
        <router-link to="/feedback" class="footer__link">{{ t('common.feedback') }}</router-link>
        <router-link to="/about" class="footer__link">{{ t('common.about') }}</router-link>
      </nav>
      <p class="footer__copyright">{{ t('site.copyright') }}</p>
    </div>
  </footer>
</template>

<style scoped>
.site-footer {
  position: relative;
  margin-top: var(--space-2xl);
  padding: var(--space-xl) 0 var(--space-lg);
}

.footer__glow-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--primary), transparent);
  opacity: 0.4;
}

.footer__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-md);
}

.footer__brand {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.footer__logo {
  font-size: 1.25rem;
}

.footer__name {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 600;
}

.footer__links {
  display: flex;
  gap: var(--space-md);
}

.footer__link {
  color: var(--text-muted);
  font-size: 0.8rem;
  transition: color var(--transition-fast);
  text-decoration: none;
}

.footer__link:hover {
  color: var(--primary);
}

.footer__copyright {
  color: var(--text-muted);
  font-size: 0.75rem;
  width: 100%;
  text-align: center;
  margin-top: var(--space-md);
  padding-top: var(--space-md);
  border-top: 1px solid var(--border-color);
}

@media (max-width: 768px) {
  .footer__inner {
    flex-direction: column;
    text-align: center;
  }
  .footer__links {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
